// extracted by mini-css-extract-plugin
export var actionButton = "_s4-0";
export var actionMenuContainer = "_s4-i";
export var bubble = "_s4-2";
export var bubbleActionMenu = "_s4-j";
export var bubbleContext = "_s4-6";
export var bubbleItems = "_s4-7";
export var customer = "_s4-3";
export var divider = "_s4-8";
export var fileList = "_s4-9";
export var hiddenComment = "_s4-o";
export var infoAbove = "_s4-a";
export var internal = "_s4-4";
export var lightActionButton = "_s4-1";
export var link = "_s4-b";
export var merchant = "_s4-5";
export var message = "_s4-c";
export var profilePicture = "_s4-e";
export var quillToolbarContainer = "_s4-f";
export var senderDate = "_s4-g";
export var senderDateCustomer = "_s4-h";
export var senderName = "_s4-d";
export var time = "_s4-k";
export var uploadedImage = "_s4-l";
export var username = "_s4-m";
export var xsmall = "_s4-n";